import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { NFSeService } from '../../../../shared/services/nfse/nfse.service';
import { urls } from './../../../../../environments/environment';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';

import * as moment from 'moment';

import { forkJoin } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-nfe',
  templateUrl: './nfse.component.html',
  styleUrls: ['./nfse.component.scss']
})
export class NFSeComponent implements OnInit, AfterViewInit {
  public nfses: any = null;
  public nfse: any = null;
  public table: any = null;
  public nfsesBkp: any = null;
  public maxTags = 4;
  public tagglejs: any = null;
  public error = false;
  public loaded = false;
  public inputSearch = '';
  public boxHidden = true;
  public finalDateFilter: Date = null;
  public initialDateFilter: Date = null;
  public showModal = false;

  constructor(
    private elRef: ElementRef,
    private NfseService: NFSeService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.clickListener();
  }

  clickListener() {
    const caixaPesquisa = this.elRef.nativeElement.querySelector('.caixa-pesquisa');
    if (caixaPesquisa) {
      const self = this;
      this.elRef.nativeElement.querySelector('.caixa-pesquisa').addEventListener('click', function(e) {
        self.elRef.nativeElement.querySelector('.input-searchbox').focus();
      });
    }
  }

  ngAfterViewInit() {
    // this.getNfse();
  }

  addTag(value) {
    this.tagglejs.add(value);
  }

  getNfse() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.NfseService.obterNotasFiscaisPorContaId(user.PersonId, moment(this.initialDateFilter).subtract(1, 'months').format('YYYY-MM-DD'), moment(this.finalDateFilter).subtract(1, 'months').format('YYYY-MM-DD')).subscribe((data: any) => {
      data.NotasFiscaisMunicipal.sort(function(a, b) {
        if (a.NumeroNfs < b.NumeroNfs) { return 1; }
        if (a.NumeroNfs > b.NumeroNfs) { return -1; }
        return 0;
      });

      data.NotasFiscaisMunicipal.forEach((nota) => {
        nota.DataEmissao = moment(nota.DataEmissao).format('DD/MM/YYYY');
        nota.ValorServico = nota.ValorServico.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      });

      this.nfses = data.NotasFiscaisMunicipal;
      this.nfsesBkp = this.nfses;

      this.filter();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    this.table = $('#master-detail-table-nfse').DataTable({
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.nfses,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.nfses && self.nfses.length === 0) {
          $('#master-detail-table-nfse_info').html('0 - 0 de 0');
        }
      },
      columns: [
        { title: 'Número', data: 'NumeroNfs' },
        { title: 'Data de Emissão', data: 'DataEmissao' },
        { title: 'Nome do Cliente', data: 'Cliente.Nome' },
        { title: 'Valor do Serviço', data: 'ValorServico' },
        {
          title: '',
          data: null,
          render: function(data, type, row, meta) {
            const NFsURL = urls.notaFiscalBase +
                           '?inscricao=' +
                           row.InscricaoMunicipal +
                           '&nota=' + row.NumeroNfs +
                           '&verificador=' + row.CodigoVerificacao;

            return '<a style="font-size: 20px;" target="_blank" href="' + NFsURL + '">' +
                      '<i class="fa fa-eye"></i>' +
                   '</a>';
          }
        },
      ],
      'order': [[ 0, 'desc' ]]
    });

    this.rowClickListener();

    $('#master-detail-table-nfse').on('page.dt', function() {
      self.rowClickListener();
    });
  }

  filter() {
    if (!this.nfses && !this.nfsesBkp) {
      this.getNfse();
      return;
    }

    this.filterByDate();
    this.filterByNumber(true);

    if (this.table) {
      this.table.destroy();
      this.showData();
    } else {
      this.showData();
    }
  }

  setFilterDate(e) {
    this.error = false;
    this.loaded = false;

    this.nfses = null;
    this.nfsesBkp = null;

    const info = document.getElementById('master-detail-table-nfse_info');
    if (info) {
      info.style.display = 'none';
    }

    const paginate = document.getElementById('master-detail-table-nfse_paginate');
    if (paginate) {
      paginate.style.display = 'none';
    }

    this.initialDateFilter = new Date(e.firstSelection.year, e.firstSelection.month, e.firstSelection.day);
    this.finalDateFilter = new Date(e.lastSelection.year, e.lastSelection.month, e.lastSelection.day);

    this.filter();
  }

  filterByNumber(init) {
    this.nfse = init ? this.nfse : this.nfsesBkp;
    const nfsAux = [];

    this.nfses.forEach((n) => {
      if (n.NumeroNfs && n.NumeroNfs.toString().includes(this.inputSearch.toLowerCase())) {
        nfsAux.push(n);
      }
    });

    this.nfses = nfsAux;
  }

  filterByDate() {
    this.nfse = this.nfsesBkp;
    const nfseAux = [];

    const initialDate = this.initialDateFilter;
    const finalDate = this.finalDateFilter;

    for (let i = 0; i < this.nfse.length; i++) {
      let date = this.nfse[i].DataEmissao.replace(/\//g, '-');

      date = date.split('-');
      date = new Date(date[2], date[1], date[0]);

      if (date >= initialDate && date <= finalDate) {
        nfseAux.push(this.nfse[i]);
      }
    }

    this.nfses = nfseAux;
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table-nfse tbody').on('click', 'tr', function(e) {
        if (e.target.className !== 'fa fa-eye') {
          const data = self.table.row(this).data();
          self.nfse = data;
          self.showModal = true;
        }
    });
  }

  eventClose() {
    this.showModal = false;
  }
}
